import React, { useState, useEffect } from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { FormGroup, Label, Input } from 'reactstrap'
import styled from 'styled-components'
import ErrorMessage from './ErrorMessage'
import Text, { useTranslations } from '../../utils/Text'
import media from '../../utils/media'

const LabelText = ({ className, label }) => (
  <Text
    id={label}
    className={className}
    linkTarget="_BLANK"
    markdown
  />
)

const Container = styled.div`
  margin-top: ${props => (props.marginT ? props.marginT : '52')}px;
  .form-check {
    max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
    padding-left: 0 !important;
  }
  .text-util p {
    font-size: 14px !important;
    text-transform: none !important;
    font-family: ${props => props.fontFamily ?? 'Raleway'};
    text-align: ${props => props.textAlign ?? 'inherit'};
  }
`

const InfoWrapper = styled.div`
  text-align: center;
  margin-bottom: 10px;
  p {
    font-family: Muli;
    font-size: 14px;
  }
  a {
    color: #414141 !important;
    text-decoration: underline !important;
  }
  em {
    font-style: normal;
    text-decoration: underline;
  }
`

const StyledLabel = styled(Label)`
  display: flex !important;
  justify-content: ${props =>
    props.justify ? props.justify : 'center'};
  .text-util {
    margin-left: 10px;
    font-weight: normal;
  }
  ${media.mobileL`
    justify-content: flex-start;
  `}
`

const StyledFormGroup = styled(FormGroup)`
  text-align: ${props => (props.align ? props.align : 'center')};
  margin: 0 auto;
  height: 100%;

  label[for='input-privacyHidden'] {
    // Created for LIC-289 - Special Check Italy
    display: none !important;
    &.showContent {
      display: flex !important;
    }
  }

  @media (max-width: 1200px) {
    /* line-height: 45px; */
  }
  @media (max-width: 352px) {
    /* line-height: 68px; */
  }
`

const StyledLabelText = styled(LabelText)`
  display: inline-block;
  padding-left: 10px;
  font-weight: normal !important;
  color: #414141;
  p {
    font-size: 14px;
  }
  a {
    color: #414141 !important;
    text-decoration: underline !important;
  }
`

const Icon = styled.svg`
  fill: none;
  stroke: #414141;
  stroke-width: 2px;
  margin-bottom: 25px;
  @media (max-width: 352px) {
    margin-bottom: 49px;
  }
`

const HiddenCheckbox = styled(Input)`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 100%;
  max-width: 20px;
  height: 20px;
  background: white;
  border: 1px solid #414141;
  border-radius: 0;
  transition: all 150ms;
  /* margin: auto 0; */
  margin: ${props =>
    props.verticalCenter ? props.verticalCenter : 'auto 0'};
  ${media.mobileL`
    /* width: 25px; */
    margin: 0 0;
  `}
  ${media.mobileM`
    /* width: 30px; */
  `}
  ${media.mobileS`
    /* width: 35px; */
  `}
  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`

export default function Checkbox({ name }) {
  const [
    {
      label,
      value,
      extraText,
      extraTextTwo,
      linkTarget,
      initialCheck,
      config,
    },
    error,
    locale,
  ] = useStoreState(state => [
    state.form.getByName(name),
    state.form.getErrorByName(name),
    state.locale.locale,
  ])
  const [
    setInputValue,
    deleteInputValue,
  ] = useStoreActions(actions => [
    actions.form.setInputValue,
    actions.form.deleteInputValue,
  ])

  const isInitialCheck = useTranslations(initialCheck, {})
  const [userCheck, setChecked] = useState(isInitialCheck)

  const LOCALE = {
    privacy: locale === 'it-it' || locale === 'es-co',
  }

  useEffect(() => {
    const subscribed = 'subscribed'
    if (isInitialCheck) {
      setInputValue({ name, value: subscribed })
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Container
      maxWidth={config && config.maxWidth}
      marginT={config && config.marginT}
      textAlign={config && config.textAlign}
      fontFamily={config && config.fontFamily}
    >
      {extraText && (
        <InfoWrapper>
          <Text id={extraText} markdown linkTarget={linkTarget} />
          <Text id={extraTextTwo} markdown linkTarget={linkTarget} />
        </InfoWrapper>
      )}
      <StyledFormGroup check align={config && config.align}>
        <StyledLabel
          className={`${LOCALE.privacy && 'showContent'}`}
          htmlFor={`input-${name}`}
          justify={config && config.justify}
          check
        >
          <HiddenCheckbox
            id={`input-${name}`}
            name={name}
            value={value}
            type="checkbox"
            checked={userCheck}
            ischecked={`${userCheck}`}
            onChange={({ target: { checked } }) => {
              setChecked(!userCheck)
              if (checked) {
                setInputValue({ name, value })
              } else {
                deleteInputValue(name)
              }
            }}
          />
          <StyledCheckbox
            id={`input-fake-${name}`}
            className="input-fake"
            checked={userCheck}
            verticalCenter={config && config.verticalCenter}
          >
            <Icon viewBox="0 0 24 24">
              <polyline points="20 6 9 17 4 12" />
            </Icon>
          </StyledCheckbox>
          <StyledLabelText label={label} />
        </StyledLabel>
        <ErrorMessage error={error} id={`error-${name}`} />
      </StyledFormGroup>
    </Container>
  )
}
